import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40219775"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "無限小数展開", -1))
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = {
  key: 2,
  style: {"overflow-x":"auto"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "d", -1))
const _hoisted_11 = {
  key: 3,
  style: {"font-size":"30px"}
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }

import { ref, shallowRef, triggerRef } from 'vue';
import { FactorC, gcdiv, factor, euler } from '@/composable/lib.ts';
import FactorStr from '@/components/FactorStr.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FracDecimal',
  setup(__props) {

class StyleC{
  marginLeft: string;
  color: string;
  constructor(){
    this.marginLeft = '0pt';
    this.color = 'black';
  }
}
class DigitC{
  q: number;
  n: number;
  sty: StyleC;
  constructor(n:number,d:number){
    this.q = Math.floor(n*10/d);
    this.n = n;
    this.sty = new StyleC();
  }
}

class OrderC{
  d: number;
  r: number;
  isPeriod: boolean;
  constructor(d:number,r:number){
    this.d = d;
    this.r = r;
    this.isPeriod = false;
  }
}

const num = ref('');
const den = ref('');
const n = ref(0);
const d = ref(0);
const start = ref(0);
let period = 0;
const nr = ref(0);
const dr = ref(0);
const np = ref(0);
const dp = ref(0);
const digits = shallowRef(new Array<DigitC>(0));
const flist = shallowRef(new Array<FactorC>(0));
const message = ref('');
const intpart = ref(0);
const limit = 10000;
const error =  ref(true);

function powdiv(a:number,n:number,m:number){ // a^n mod m
  if(n == 0){
    return(1);
  }else if(n % 2 == 0){
    let x = powdiv(a,n/2,m);
    return(x*x % m);
  }else{
    return(powdiv(a,n-1,m) * a % m);
  }
}

function calc(){
  let n_local = Number(num.value);
  let d_local = Number(den.value);
  if(! Number.isInteger(n_local) || n_local <= 0){
    message.value = '分子は正の整数にしてください。';
    error.value = true;
    return;		
  }
  if(! Number.isInteger(d_local) || d_local <= 0){
    message.value = '分母は正の整数にしてください。';
    error.value = true;
    return;		
  }

  error.value = false;
  digits.value.splice(0);
  n.value = n_local;
  d.value = d_local;

  const gcd = gcdiv(n_local,d_local);
  nr.value = n_local/gcd;
  dr.value = d_local/gcd;

  let np_local = n_local/gcd;
  let dp_local = d_local/gcd;
  let start_local = 0;
  while(dp_local % 2 == 0 || dp_local % 5 == 0){
    if(dp_local % 10 == 0){
      dp_local /= 10;
    }else if(dp_local % 2 == 0){
      dp_local /= 2;
      np_local *= 5;
    }else if(dp_local % 5 == 0){
      dp_local /= 5;
      np_local *= 2;
    }
    start_local += 1;
  }
  np.value = np_local;
  dp.value = dp_local;
  start.value = start_local;
  flist.value.splice(0);
  
  if(dp_local != 1){
    const ar = factor(euler(dp_local));
    flist.value.push(new OrderC(1,10 % dp_local));
    for(const obj of ar){
      let l2 = new Array<OrderC>();
      for(const x of flist.value){
	let d = x.d;
	let r = x.r;
	for(let e=1; e<=obj.e;e++){
	  d *= obj.p;
	  r = powdiv(r,obj.p,dp_local);
	  l2.push(new OrderC(d,r));
	}
      }
      Array.prototype.push.apply(flist.value,l2);
    }
    flist.value.sort((a,b) => a.d-b.d);
    triggerRef(flist);
  }
  
  for(let i=0;i<flist.value.length;i++){
    if(flist.value[i].r == 1){
      period = flist.value[i].d;
      flist.value[i].isPeriod = true;
      triggerRef(flist);
      break;
    }
  }
	    
  if(dr.value == 1){
    message.value = '整数';
  }else if(dp_local == 1){
    message.value = '有限小数';
  }else{
    message.value = `循環節の長さ = ${period}`;
  }

  intpart.value = Math.floor(n_local/d_local);
  n_local = n_local % d_local;
  for(let i = 0; i<limit;i++){
    if(n_local == 0){
      return;
    }
    const data = new DigitC(n_local,d_local);
    digits.value.push(data);
    if(i >= start.value && i < start.value + period){
      digits.value[i].sty.color = 'red';
    }
    if( i>0 && i >= start.value && (i - start.value) % period == 0  ){
      digits.value[i].sty.marginLeft = '10px';
    }
    if( i > 20 && i > start.value + 3*period ){
      return;
    }
    n_local = n_local*10 % d_local;
  }
  return;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((num).value = $event)),
          type: "text",
          class: "wide"
        }, null, 512), [
          [_vModelText, num.value]
        ]),
        _createTextVNode(" / "),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((den).value = $event)),
          type: "text",
          class: "wide"
        }, null, 512), [
          [_vModelText, den.value]
        ]),
        _createElementVNode("button", { onClick: calc }, "計算")
      ]),
      (! error.value && dp.value != d.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(n.value) + " / " + _toDisplayString(d.value), 1),
            (n.value != nr.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, " = " + _toDisplayString(nr.value) + " / " + _toDisplayString(dr.value), 1))
              : _createCommentVNode("", true),
            (start.value > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createTextVNode(" = 10"),
                  _createElementVNode("sup", null, "-" + _toDisplayString(start.value), 1),
                  _createTextVNode(" × " + _toDisplayString(np.value) + " ", 1),
                  (dp.value > 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "/ " + _toDisplayString(dp.value), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (! error.value && dp.value > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createTextVNode(_toDisplayString(dp.value) + " = ", 1),
            _createVNode(FactorStr, { n: dp.value }, null, 8, ["n"]),
            _createTextVNode(),
            _hoisted_8,
            _createTextVNode(" φ(" + _toDisplayString(dp.value) + ") = " + _toDisplayString(_unref(euler)(dp.value)) + " = ", 1),
            _createVNode(FactorStr, {
              n: _unref(euler)(dp.value)
            }, null, 8, ["n"])
          ]))
        : _createCommentVNode("", true),
      (! error.value && dp.value > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("table", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, " φ(" + _toDisplayString(dp.value) + ") の約数 d ", 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flist), (x) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: x.d,
                    class: _normalizeClass({period: x.isPeriod})
                  }, _toDisplayString(x.d), 3))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createTextVNode(" 10"),
                  _hoisted_10,
                  _createTextVNode(" mod " + _toDisplayString(dp.value), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flist), (x) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: x.d,
                    class: _normalizeClass({period: x.isPeriod, one:x.r == 1})
                  }, _toDisplayString(x.r), 3))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, _toDisplayString(message.value), 1),
      (! error.value && d.value != 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createTextVNode(_toDisplayString(n.value) + " / " + _toDisplayString(d.value) + " = ", 1),
            _createElementVNode("span", null, _toDisplayString(intpart.value), 1),
            (_unref(digits).length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                  _createTextVNode(". "),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(digits), (dd, i) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: i,
                      class: "digit",
                      style: _normalizeStyle(dd.sty)
                    }, _toDisplayString(dd.q), 5))
                  }), 128)),
                  (dp.value != 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "……"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})